module.exports = __webpack_public_path__ + "img/desktop-1.36e6caf6.jpg";